import { fetchProvRates, fetchProviders } from "../utils/api";
import { useState, useEffect } from "react";
export const useProviders = () => {
  const [providers, setProviders] = useState<any>([]);
  const [rates, setRates] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const fetchDataP = async () => {
    setLoading(true);
    try {
      const [ratesRes, providerRes] = await Promise.all([
        fetchProvRates(),
        fetchProviders(),
      ]);
      setProviders(providerRes.data);
      setRates(ratesRes.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Ошибка при загрузке!");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDataP();
  }, []);

  return {
    providers,
    loading,
    error,
    rates,
    setRates,
    fetchDataP,
  };
};
